module.exports = __webpack_public_path__ + "img/primary_11x4_z16.602123f7.svg";